/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';

// eslint-disable-next-line
declare var document: any;

const ScriptStore: ExternalScripts[] = [
  // {
  //     name: 'googleMaps',
  //     src:
  //         'https://maps.google.com/maps/api/js?key=AIzaSyCiNBT6rUZvmx1Zw4DX_G3O_3FLtw11UXI&libraries=places&language=en-US',
  //     loaded: false,
  // },
  {
    name: 'stripeJs',
    src: 'https://js.stripe.com/v3/',
    loaded: false,
  },
  {
    name: 'plaid',
    src: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js',
    loaded: false,
  },
];

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  scripts: any[] = [];

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = script;
    });
  }

  load(...scripts: string[]): Promise<any> {
    return Promise.all(scripts.map((script) => this.loadScript(script)));
  }

  loadScript(name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {
          // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}

interface ExternalScripts {
  name: string;
  src: string;
  loaded?: boolean;
}
